// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DependenciesOutlinedSvg from "@fishx/icons-svg/es/asn/DependenciesOutlined";
import FishxIcon from '../components/FishxIcon';

var DependenciesOutlined = function DependenciesOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DependenciesOutlinedSvg
  }));
};

DependenciesOutlined.displayName = 'DependenciesOutlined';
export default React.forwardRef(DependenciesOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DependenciesOutlined.js
// module id = 2404
// module chunks = 0